import React, { lazy, Suspense } from "react";

export default (loader: any) => {
  const OtherComponent = lazy(loader);

  const Component = () => {
    return (
      <Suspense fallback={ null }>
        <OtherComponent />
      </Suspense>
    );
  };

  return Component;
}
